import {Injectable} from '@angular/core';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class SclUtilDateService {

  constructor() { }

  getLocalFromUTCString(UTCTime) {
     // It'll convert the utc -> localtime
    return new Date(UTCTime);
  }
  // LocalTime must be formatted at ISOString i.e 2015-04-08T12:12:12.000Z
  getUTCFromLocalString(localTime) {
    let dateTime = localTime.replace('T', ' ').replace('Z', '');
    dateTime = new Date(dateTime); // create date object
    return dateTime.toISOString();
  }

  parseDate(date, format) {
    return moment(date).format(format);
  }
  isDate(dateObject) {
    if (Object.prototype.toString.call(dateObject) === '[object Date]') {
      if (isNaN(dateObject.getTime()) === false) {
        return true;
      }
    }
    return false;
  }

  isValidDate(date) {
    // An invalid date object returns NaN for getTime() and NaN is the only
    // object not strictly equal to itself.
    return date.getTime() === date.getTime();
  }

  formatDate(time) {
    return moment(time).fromNow();
  }
  getValidDate(value) {
    let validValue;
    if (!value) {
      validValue = new Date();
    } else {
      if (this.isValidDate(value)) {
        validValue = value;
      } else {
        const date = moment(value, ['DD/MM/YYYY hh:mm a', 'DD/MM/YYYY', 'hh:mm a', moment.ISO_8601], true);
        if (date.isValid()) {
          validValue = date.toDate();
        } else {
          validValue = new Date();
        }
      }
    }
    return validValue;
  }
  getFormattedDate(dateValue) {
    if (!dateValue) {
      return dateValue;
    }
    let formattedDate;
    let d; d = new Date(dateValue);
    const defaultYear = new Date();
    if (d.getFullYear() < 1) {
      d.setYear(defaultYear.getFullYear());
      formattedDate = d;
    } else {
      formattedDate = d;
    }
    return formattedDate;
  }

}
